import { render, staticRenderFns } from "./modal-feedback.html?vue&type=template&id=3b4e7c99&scoped=true&external"
import script from "./modal-feedback.js?vue&type=script&lang=js&external"
export * from "./modal-feedback.js?vue&type=script&lang=js&external"
import style0 from "./modal-feedback.scss?vue&type=style&index=0&id=3b4e7c99&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e7c99",
  null
  
)

export default component.exports